.fulfillment {
  display: grid;
  gap: var(--sc-spacing-x-large);

  &__number {
    font-weight: bold;
  }
  &__header {
    display: flex;
    align-items: center;
    gap: var(--sc-spacing-medium);
  }
}

sc-card {
  --sc-card-padding: var(--sc-spacing-x-large);
}

.trackings {
  display: flex;
  gap: 0.75em;
  color: var(--sc-line-item-title-color, var(--sc-input-label-color));

  &__title {
    line-height: var(--sc-line-height-dense);
    font-weight: var(--sc-font-weight-bold);
  }

  sc-icon {
    opacity: 0.5;
    font-size: 22px;
  }
}

.line_items {
  display: grid;
  gap: var(--sc-spacing-large);
}

.line_item {
  &__info {
    display: flex;
    gap: var(--sc-spacing-medium);
    align-items: center;
  }

  &__image img {
    width: var(--sc-product-line-item-image-size, 4em);
    height: var(--sc-product-line-item-image-size, 4em);
    object-fit: cover;
    border-radius: 4px;
    border: solid 1px var(--sc-input-border-color, var(--sc-input-border));
    display: block;
    box-shadow: var(--sc-input-box-shadow);
  }
}
